import { Typography, TypographyProps } from "@mui/material";
import { SystemStyleObject, Theme } from "@mui/system";

type StyleNames = "textOverflow" | "overflow" | "whiteSpace";

type Props = Omit<TypographyProps, StyleNames | "sx"> & {
  sx?: Omit<SystemStyleObject<Theme>, StyleNames>;
  component?: string;
};

/**
 * Truncation may may also depend on the nearest flex child ancestor
 * having a minWidth, as explained in:
 * https://css-tricks.com/flexbox-truncated-text/
 */
export default function TruncatedTypography(props: Props) {
  return (
    <Typography
      {...props}
      sx={[
        {
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    />
  );
}
